import React from "react";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './App.css';
import { Route } from 'react-router';
import { Container } from '@material-ui/core';
//import { Counter } from './components/Counter';
//import { Docx2 } from './components/docx2/Docx2';
//import { RoleAndUser } from './components/role_and_user/RoleAndUser';
import { RequestInformation } from './components/request_information/RequestInformation';
import { EvaWaiver } from './components/eva_waiver/EvaWaiver';
import { Waivers } from "./components/eva_waiver/Waivers";
import {Phish2} from './components/phish2/Phish2';
function App() {
  return (
    <div className="App">
        <Container>
            <DndProvider backend={HTML5Backend}>
                {
                    /*
                    <Route path='/counter' component={Counter} />
                <Route path='/docx2' component={Docx2} />
                <Route path='/roleAndUser' component={RoleAndUser}/>
                <Route path='/request_information' component={RequestInformation} />
                
                     */
                }
                <Route path='/evaWaiver' component={EvaWaiver}/>
                <Route path='/waivers' component={Waivers}/>
                <Route path='/phish2' component={Phish2}/>
                <Route path='/phish' component={Phish2}/>
                <Route path='/request_information' component={RequestInformation}/>
            </DndProvider>
        </Container>
    </div>
  );
}

export default App;
